/*
 * SuccessTitle.jsx
 * Description:
 * Copyright (c) 2021 PredictiveUX
 */
import React from 'react';

const SuccessTitle = () => (
  <div className="create-account__line-container">
    <div className="create-account__title">Your transfer is now pending.</div>
  </div>
);

export default SuccessTitle;
